export default "__VITE_ASSET__CKn4msMa__"